var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.dataSource.length ? [_vm._t("content")] : _vm._e(),
      !_vm.dataSource.length
        ? _c(
            "div",
            {
              class: {
                "flex-center": true,
                "flex-page-center": _vm.isSetPageCenter,
              },
              style: _vm.styleObj,
            },
            [
              _c(
                "div",
                [
                  _vm.loading
                    ? _c("a-spin", { attrs: { size: "large" } })
                    : !_vm.loading && _vm.isEmpty
                    ? _c("a-empty")
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }